import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Navbar from './navbar/Navbar';
import Sidebar from './sidebar/Sidebar';
import { navbarConfig, sidebarConfig } from '../constants/navigationConfig';
import MobileSidebar from './sidebar/MobileSidebar';
import { useLocation } from 'react-router-dom';
import { RootState } from '../store';
import { setShowMobileSidebar } from '../store/slices/sidebarSlice';

interface LayoutProps {
  children: React.ReactNode;
  sidebarPosition?: 'left' | 'right';
}

const Layout: React.FC<LayoutProps> = ({
  children,
  sidebarPosition = 'left',
}) => {
  const dispatch = useDispatch();
  const showMobileSidebar = useSelector((state: RootState) => state.sidebar.showMobileSidebar);
  const prevPath = useRef('');
  const { pathname } = useLocation();

  useEffect(() => {
    if (prevPath.current !== pathname) {
      dispatch(setShowMobileSidebar(false));
    }

    prevPath.current = pathname;
  }, [pathname, dispatch]);

  return (
    <div className="min-h-screen h-[100dvh] w-screen flex relative lg:p-4 bg-background-card">
      <div
        className={`flex w-full h-full gap-3 ${
          sidebarPosition === 'right' ? 'flex-row-reverse' : 'flex-row'
        }`}
      >
        <Sidebar config={sidebarConfig} />
        <div className="flex-1 flex flex-col lg:gap-3 w-full lg:h-full lg:overflow-auto">
          <div className="flex-none z-50 relative">
            <Navbar config={navbarConfig} setShowSidebar={(show) => dispatch(setShowMobileSidebar(show))} />
          </div>
          {showMobileSidebar ? (
            <MobileSidebar
              config={sidebarConfig}
              setShowSidebar={(show) => dispatch(setShowMobileSidebar(show))}
            />
          ) : (
            <main className={'flex-1 h-full overflow-y-auto lg:rounded-lg [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]'}>{children}</main>
          )}
        </div>
      </div>

      {/* <Notifications /> */}
    </div>
  );
};

export default Layout;
